import { gql } from '@apollo/client';

export default gql`
  mutation upgradeMembership($membershipId: String!, $productId: String!, $enteredCoupon: String) {
    upgradeMembership(membershipId: $membershipId, productId: $productId, enteredCoupon: $enteredCoupon) {
      startDate
      productPrice
      couponName
      couponCredit
      prorateCredit
      totalCost
    }
  }
`;
